module.exports = __webpack_public_path__ + "static/URT__white solid-64e0b07ce46d330f130af080acf784b5.svg";